import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import pendingUserIcon from "../../../assets/management/pending_user.svg";

import styles from "./PendingUserIcon.module.css";

const PendingUserIcon = () => {
  return <BaseIcon icon={pendingUserIcon} className={styles.icon} />;
};

export default PendingUserIcon;
